/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsDynamoDBDestination } from '../models/AwsDynamoDBDestination';

export class DynamodbTableRestoreDestination {
  'awsDynamodb'?: AwsDynamoDBDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "awsDynamodb",
      "baseName": "awsDynamodb",
      "type": "AwsDynamoDBDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DynamodbTableRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

